import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  makeStyles,
  Grid,
  IconButton,
  Box,
} from '@material-ui/core';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Card from './Card';

const useStyles = makeStyles({
  card: {
    padding: '20px 25px',
    cursor: 'pointer',
  },
  title: {
    marginBottom: 5,
    fontSize: 14,
  },
  task: {
    textAlign: 'left',
  },
});
const NotificationTaskDrawer = props => {
  const classes = useStyles();
  const { title, detail, hasAction = false, onAction = () => {} } = props;

  return (
    <Card variant="white">
      <Grid
        container
        className={classes.card}
        direction="row"
        alignItems="center"
        onClick={onAction}
      >
        <Grid item xs={hasAction ? 11 : 12}>
          <Grid container>
            <Grid item>
              <Typography
                variant="body1"
                color="secondary"
                className={classes.title}
                component="div"
              >
                <Box fontWeight="fontWeightBold">{title}</Box>
              </Typography>
            </Grid>
            <Grid container>
              <Grid item>
                <Typography
                  variant="body1"
                  color="textSecondary"
                  className={classes.task}
                >
                  {detail}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {hasAction && (
          <Grid item xs={1}>
            <IconButton onClick={onAction}>
              <ArrowForwardIosIcon
                color="secondary"
                fontSize="small"
                className={classes.icon}
              />
            </IconButton>
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

NotificationTaskDrawer.defaultProps = {
  hasAction: false,
  onAction: () => {},
};

NotificationTaskDrawer.propTypes = {
  title: PropTypes.string.isRequired,
  detail: PropTypes.string.isRequired,
  hasAction: PropTypes.bool,
  onAction: PropTypes.func,
};

export default NotificationTaskDrawer;
